import React from "react";
import ScanMainView from "./template/ScanMainView";
import propsProvider from "./ScanPropsProvider";
import { useIntl } from "react-intl";
function ScanContainer(props) {
  const { history } = props;
  const intl = useIntl();
  const handleScan = (result) => {
    const targetUrl = result?.data || "";
    const splitCode = targetUrl.split("?")[1];
    if (splitCode.substring(0, 4) === "code") {
      return history.push(`/product?${splitCode}`);
    }
  };
  const handScanError = () => {
    history.push("/empty");
  };

  const scanContainerProps = {
    ...props,
    intl,
    handleScan,
    handScanError,
  };
  return <ScanMainView {...propsProvider(scanContainerProps)} />;
}

export default ScanContainer;
